import { Cookies } from 'react-cookie';

import { SmartSnapTrapData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export type TrapKind = 'smst' | 'srst';

export const getSnapTrapTraps = async (slug: string, kind: TrapKind) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get<SmartSnapTrapData[]>(`/traps/${kind}/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as SmartSnapTrapData[];
};
